/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type UploadWorkspaceArchiveRequest = {
  sessionId: string;
  sessionToken?: string | null | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  requestBody?:
    | ReadableStream<Uint8Array>
    | Blob
    | ArrayBuffer
    | Uint8Array
    | undefined;
};

/** @internal */
export const UploadWorkspaceArchiveRequest$inboundSchema: z.ZodType<
  UploadWorkspaceArchiveRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  session_id: z.string(),
  session_token: z.nullable(z.string()).optional(),
  "X-On-Behalf-Of": z.string().optional(),
  RequestBody: z.union([
    z.instanceof(ReadableStream<Uint8Array>),
    z.instanceof(Blob),
    z.instanceof(ArrayBuffer),
    z.instanceof(Uint8Array),
  ]).optional(),
}).transform((v) => {
  return remap$(v, {
    "session_id": "sessionId",
    "session_token": "sessionToken",
    "X-On-Behalf-Of": "xOnBehalfOf",
    "RequestBody": "requestBody",
  });
});
/** @internal */
export type UploadWorkspaceArchiveRequest$Outbound = {
  session_id: string;
  session_token?: string | null | undefined;
  "X-On-Behalf-Of"?: string | undefined;
  RequestBody?:
    | ReadableStream<Uint8Array>
    | Blob
    | ArrayBuffer
    | Uint8Array
    | undefined;
};

/** @internal */
export const UploadWorkspaceArchiveRequest$outboundSchema: z.ZodType<
  UploadWorkspaceArchiveRequest$Outbound,
  z.ZodTypeDef,
  UploadWorkspaceArchiveRequest
> = z.object({
  sessionId: z.string(),
  sessionToken: z.nullable(z.string()).optional(),
  xOnBehalfOf: z.string().optional(),
  requestBody: z.union([
    z.instanceof(ReadableStream<Uint8Array>),
    z.instanceof(Blob),
    z.instanceof(ArrayBuffer),
    z.instanceof(Uint8Array),
  ]).optional(),
}).transform((v) => {
  return remap$(v, {
    sessionId: "session_id",
    sessionToken: "session_token",
    xOnBehalfOf: "X-On-Behalf-Of",
    requestBody: "RequestBody",
  });
});

export function uploadWorkspaceArchiveRequestToJSON(
  uploadWorkspaceArchiveRequest: UploadWorkspaceArchiveRequest,
): string {
  return JSON.stringify(
    UploadWorkspaceArchiveRequest$outboundSchema.parse(
      uploadWorkspaceArchiveRequest,
    ),
  );
}
export function uploadWorkspaceArchiveRequestFromJSON(
  jsonString: string,
): SafeParseResult<UploadWorkspaceArchiveRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UploadWorkspaceArchiveRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UploadWorkspaceArchiveRequest' from JSON`,
  );
}
